// Tracks whether a save (and its uploads) is still running, app-wide.
//
// Leaving mid-save is how Material Catalogue PDFs ended up uploaded to Storage
// but never linked to their product. While any save is running:
// - closing, reloading or typing a new URL gets the browser's own "Leave site?"
//   prompt (browsers no longer show custom text there);
// - in-app navigation and Logout ask with SAVE_INTERRUPT_MESSAGE instead —
//   pages call confirmInterruptSave() from their blocker, App.js from Logout.
//
// A counter rather than a flag, so two overlapping saves do not let the first
// one to finish switch the guard off for the other.

export const SAVE_INTERRUPT_MESSAGE =
  'A save is still in progress. Leaving now will interrupt it and files may not be attached. Leave anyway?';

let active = 0;

function onBeforeUnload(e) {
  e.preventDefault();
  e.returnValue = '';
}

/** Call when a save starts. Returns the function to call when it ends (call it in `finally`). */
export function beginSave() {
  if (active === 0) window.addEventListener('beforeunload', onBeforeUnload);
  active += 1;
  let ended = false;
  return () => {
    if (ended) return;
    ended = true;
    active -= 1;
    if (active === 0) window.removeEventListener('beforeunload', onBeforeUnload);
  };
}

export function isSaveInProgress() {
  return active > 0;
}

/** True when it is fine to leave: no save running, or the user chose to interrupt it. */
export function confirmInterruptSave() {
  return !isSaveInProgress() || window.confirm(SAVE_INTERRUPT_MESSAGE);
}
